let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("HOIkg")).then(() => parcelRequire('goMQ6'));